module.exports = __webpack_public_path__ + "static/media/zara_th.3c8062f8.png";